import { Box, Typography } from "@mui/material"
import { RecruitmentBox } from "../../styles/AdvisorStyles"
import { Link } from "react-router-dom"
import { Plus, Link2, Repeat2 } from "lucide-react";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { AdvisorLeads } from "../advisor/AdvisorLeads"   
import { IProject } from "../../../../types"

export const OutreachPrompts = ({project}: {project: IProject}) => {

    return (
        <Box sx={{ margin: "0 auto", display: "flex", flexDirection: "column", alignItems: "center", gap: "20px", "& a": {textDecoration: "none !important"} }}>
        <Typography sx={{ textAlign: "center", fontWeight: "700" }}>
            Start recruiting your own advisors...
        </Typography>
        <Box sx={{ 
            display: "grid", 
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "20px", 
            width: "100%", 
            "& > a": { 
                display: "flex", 
                height: "100%" 
            },
            "@media (max-width: 1120px)": {
                gridTemplateColumns: "repeat(2, 1fr)",
                gridTemplateRows: "repeat(2, auto)"
            },
            "@media (max-width: 600px)": {
                gridTemplateColumns: "1fr",
                gridTemplateRows: "repeat(4, auto)"
            }
        }}>
            <Link to="suggest">
                <RecruitmentBox sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
                    <Plus className="icon" size={24} />
                    <Typography variant="h6">Suggest Advisors</Typography>
                    <Typography>
                        Manually add potential advisors or upload a CSV of contacts
                    </Typography>
                </RecruitmentBox>
            </Link>

            <Link to="links">
                <RecruitmentBox sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
                    <Link2 className="icon" size={24} />
                    <Typography variant="h6">Invitation Links</Typography>
                    <Typography>
                        Get shareable links to invite advisors via email or messages
                    </Typography>
                </RecruitmentBox>
            </Link>

            <Link to="linkedin">
                <RecruitmentBox sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
                    <FontAwesomeIcon icon={faLinkedin} className="icon" />
                    <Typography variant="h6">Scan LinkedIn</Typography>
                    <Typography>
                        Search your LinkedIn network for potential advisors
                    </Typography>
                </RecruitmentBox>
            </Link>

            <Link to="campaigns">
                <RecruitmentBox sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
                    <Repeat2 className="icon" size={24} />
                    <Typography variant="h6">Paid Campaigns</Typography>
                    <Typography>
                    Launch targeted outreach campaigns to find advisors
                    </Typography>
                </RecruitmentBox>
            </Link>
        </Box>

    </Box>
    )
}